import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { APPRAISAL_SURCHARGES_ACTION_TYPE } from '../actions';

const initialState = {
  appraisalSurcharges: {},
};

const getEntityId = entity => entity.appraisalSurchargeId || entity.id;

const appraisalSurchargesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case APPRAISAL_SURCHARGES_ACTION_TYPE.GET_APPRAISAL_SURCHARGES:
        draft.appraisalSurcharges = payload || initialState.appraisalSurcharges;
        break;

      case APPRAISAL_SURCHARGES_ACTION_TYPE.CREATE_APPRAISAL_SURCHARGE:

      case APPRAISAL_SURCHARGES_ACTION_TYPE.UPDATE_APPRAISAL_SURCHARGE: {
        const id = getEntityId(payload);
        draft.appraisalSurcharges[id] = payload;
        break;
      }

      case APPRAISAL_SURCHARGES_ACTION_TYPE.DELETE_APPRAISAL_SURCHARGE:
        delete draft.appraisalSurcharges[meta.id];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default appraisalSurchargesReducer;
